import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Tooltip from "@mui/material/Tooltip";
import { red } from "@mui/material/colors";
import React from "react";

export default function PlanFeature({ planFeature }) {
  return (
    <div className="border-t border-gray-100 bg-gray-50/50">
      <ul className="p-4 space-y-3">
        {planFeature.map((item, index) => {
          return (
            <React.Fragment key={index}>
              {item?.display === 1 ? (
                <li
                  key={index}
                  className="flex items-center justify-between py-1"
                >
                  <div className="flex items-center">
                    <span className="text-sm text-gray-700">{item.name}</span>
                    <div className="ml-2">
                      <Tooltip
                        title={item.description}
                        arrow
                        placement="top"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "rgba(97, 97, 97, 0.95)",
                              color: "white",
                              fontSize: "12px",
                              maxWidth: "250px",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              boxShadow: "0 4px 14px rgba(0, 0, 0, 0.15)",
                            },
                          },
                          arrow: {
                            sx: {
                              color: "rgba(97, 97, 97, 0.95)",
                            },
                          },
                        }}
                      >
                        <span className="inline-flex items-center justify-center w-4 h-4 text-xs text-gray-500 bg-gray-200 rounded-full cursor-help hover:bg-gray-300 transition-colors">?</span>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="flex items-center text-sm">
                    {item.value === "yes" ? (
                      <CheckCircleIcon
                        color="success"
                        sx={{ fontSize: 18 }}
                      />
                    ) : item.value === "no" ? (
                      <CancelIcon
                        sx={{ fontSize: 18, color: red[500] }}
                      />
                    ) : (
                      <span className="text-gray-600 font-medium">{item.value}</span>
                    )}
                  </div>
                </li>
              ) : null}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
}
